import { useEffect, useState } from "react";

export const useModalTrigger = (key: string, defaultValue = false) => {
  const [isVisible, setIsVisible] = useState(defaultValue);

  useEffect(() => {
    const handleShowModal = () => {
      setIsVisible(true);
    };

    // @ts-ignore
    window.addEventListener(key, handleShowModal);
    return () => {
      // @ts-ignore
      window.removeEventListener(key, handleShowModal);
    };
  }, []);

  return [isVisible, setIsVisible] as const;
};
